import { getMessages } from '../../../../../../../store/constants';

export const TOOLTIP_START_DATE = getMessages().getText('kanban.start_date_tooltip');
export const TOOLTIP_DUE_DATE = getMessages().getText('kanban.due_date_tooltip');

export const DATE_SHORT_FORMAT = 'D MMM';
export const DATE_TOOLTIP_FORMAT = 'D MMM YYYY HH:mm';
